



export const LANG_KEY = "language";           
export const DEFAULT_LANG = "de";             


export const breakpointOrder = ["xs", "sm", "md", "lg", "xl", "xxl"];


export const SCROLL_ACTIVATE_THRESHOLD = 0.3;

export const scrollOffsetMap = {
  "#section-agentur": [
    { applyAt: "xs", offset: -50 },
    { applyAt: "md", offset: -100 },
    { applyAt: "lg", offset: 0 },
  ],
  "#section-kontakt": [{ applyAt: "lg", offset: 300 }],
  "#section-hero": [{ applyAt: "xs", offset: 0 }],
};
 